import { render, staticRenderFns } from "./ListPostingAsset.vue?vue&type=template&id=3952f646&"
import script from "./ListPostingAsset.vue?vue&type=script&lang=ts&"
export * from "./ListPostingAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3952f646')) {
      api.createRecord('3952f646', component.options)
    } else {
      api.reload('3952f646', component.options)
    }
    module.hot.accept("./ListPostingAsset.vue?vue&type=template&id=3952f646&", function () {
      api.rerender('3952f646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Additions/ListPostingAsset.vue"
export default component.exports